const API_BASE = process.env.REACT_APP_API_URL || 'https://auth-service-cprl.onrender.com';

export const AUTH_API = 'https://auth-service-cprl.onrender.com';
export const BEAM_API = 'https://beam-service.onrender.com';
export const PLAGIARISM_API = 'https://plagiarism-service.onrender.com';
export const HUMANIZER_API = 'https://ook-calculators-humanizer.hf.space';
export const AI_DETECTOR_API = 'https://ook-calculators-ai-detector.hf.space';
export const GRAMMAR_API = 'http://localhost:5006';
export const PARAPHRASE_API = 'http://localhost:5007';
export const SUMMARIZER_API = 'https://ook-calculators-summarizer.hf.space';

export default API_BASE;
